"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _prismicClient = _interopRequireDefault(require("../prismicClient"));

var _BasicTemplate = _interopRequireDefault(require("./templates/BasicTemplate"));

var _DRPETemplate = _interopRequireDefault(require("./templates/DRPETemplate"));

var _query = _interopRequireDefault(require("./helpers/query"));

var _normalizer = _interopRequireDefault(require("./helpers/normalizer"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var templateMap = {
  Basic: _BasicTemplate["default"],
  DRPE: _DRPETemplate["default"]
};

var ProgramPage = /*#__PURE__*/function (_Component) {
  _inherits(ProgramPage, _Component);

  var _super = _createSuper(ProgramPage);

  function ProgramPage(props) {
    var _this;

    _classCallCheck(this, ProgramPage);

    _this = _super.call(this, props);
    var siteId = props.siteId,
        instanceId = props.instanceId,
        errorHandler = props.errorHandler;
    _this.state = {
      pageData: null
    };
    _this.setComponentState = _this.setComponentState.bind(_assertThisInitialized(_this));
    _this.dataClient = new _prismicClient["default"](_this.setComponentState);

    _this.dataClient.fetchData((0, _query["default"])(siteId, instanceId), _normalizer["default"], errorHandler);

    return _this;
  }

  _createClass(ProgramPage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var callbackFunc = this.props.callbackFunc;
      callbackFunc.call(this);
    }
  }, {
    key: "setComponentState",
    value: function setComponentState(state) {
      if (state && (!state.page_template || !templateMap[state.page_template])) {
        var errorHandler = this.props.errorHandler;
        return errorHandler('Content is defined, but no template is available.', true);
      }

      this.setState({
        pageData: state
      });
    }
  }, {
    key: "render",
    value: function render() {
      var pageData = this.state.pageData;

      if (!pageData) {
        return null;
      }

      var Template = templateMap[pageData.page_template];
      return /*#__PURE__*/_react["default"].createElement(Template, {
        pageData: pageData,
        dataClient: this.dataClient
      });
    }
  }]);

  return ProgramPage;
}(_react.Component);

ProgramPage.propTypes = {
  siteId: _propTypes["default"].string.isRequired,
  instanceId: _propTypes["default"].string.isRequired,
  errorHandler: _propTypes["default"].func.isRequired,
  callbackFunc: _propTypes["default"].func
};
ProgramPage.defaultProps = {
  callbackFunc: function callbackFunc() {}
};
var _default = ProgramPage;
exports["default"] = _default;